import {
  boolean,
  forward,
  number,
  object,
  partialCheck,
  pipe,
  string,
  type InferOutput
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

/**
 * 月次支払レポートのステータス更新のフォームスキーマ
 */
export const monthlyTourReportUpdateStatusFormValueSchema = pipe(
  object({
    tenantKey: string(),
    reportId: number(),
    /** 差し戻し理由 */
    comment: string(),
    /** 差し戻しかどうか */
    isReject: boolean()
  }),
  forward(
    partialCheck(
      [['isReject'], ['comment']],
      ({ isReject, comment }) => (isReject ? comment.length > 0 : true),
      VALIDATION_MESSAGES.REQUIRED_ITEM
    ),
    ['comment']
  )
)

/**
 * 月次支払レポートのステータス更新のフォーム値
 */
export type MonthlyTourReportUpdateStatusFormValue = InferOutput<
  typeof monthlyTourReportUpdateStatusFormValueSchema
>
